import React from 'react';
import Icon from '../../../components/AppIcon';

const ApprovalKPICards = ({ kpis, loading }) => {
  const cards = [
    {
      label: 'Overall Approval Rate',
      value: loading ? '—' : `${kpis?.approvalRate ?? 0}%`,
      sub: `${kpis?.totalDecided ?? 0} decisions made`,
      icon: 'TrendingUp',
      color: 'text-green-600',
      bg: 'bg-green-50',
      border: 'border-green-200',
    },
    {
      label: 'Avg Response Time',
      value: loading ? '—' : kpis?.avgResponseTime ?? '—',
      sub: 'From request to decision',
      icon: 'Timer',
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      border: 'border-blue-200',
    },
    {
      label: 'Total Approvals',
      value: loading ? '—' : kpis?.total ?? 0,
      sub: `${kpis?.pending ?? 0} still pending`,
      icon: 'ClipboardCheck',
      color: 'text-purple-600',
      bg: 'bg-purple-50',
      border: 'border-purple-200',
    },
    {
      label: 'Rejection Rate',
      value: loading ? '—' : `${kpis?.rejectionRate ?? 0}%`,
      sub: `${kpis?.totalRejected ?? 0} rejected`,
      icon: 'XCircle',
      color: 'text-red-600',
      bg: 'bg-red-50',
      border: 'border-red-200',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {cards?.map((card) => (
        <div key={card?.label} className={`bg-card border ${card?.border} rounded-xl p-5`}>
          <div className="flex items-start justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg ${card?.bg} flex items-center justify-center`}>
              <Icon name={card?.icon} size={20} className={card?.color} />
            </div>
          </div>
          <p className={`text-2xl font-bold ${card?.color} mb-1`}>{card?.value}</p>
          <p className="text-sm font-medium text-foreground">{card?.label}</p>
          <p className="text-xs text-muted-foreground mt-0.5">{card?.sub}</p>
        </div>
      ))}
    </div>
  );
};

export default ApprovalKPICards;
